import schemePlanning from "./modules/schemePlanning";
import communication from "./modules/communication";
import masters from "./modules/masters";
import menus from "./modules/menus";
import workflow from "./modules/workflow";
import BaseService from "@/services/BaseService";
import accrual from "./modules/Accrual"
import configuration from "./modules/configuration";
import reports from "./modules/reports";
import branchScheme from "./modules/branchScheme"
import tradePlan from "./modules/tradePlan";
import bulkPayoutManualUpload from "./modules/bulkPayoutManualUpload";
import nerp from "./modules/nerp";

export default {
    state: {
      pageTitle: "",
      pageTitleUrl: "",
      breadcrumbs: [],
      pageLoader: false,
      userInfo: {},
      userType: {},
      imsUserMenuss: [],
      activeSnackbar: {
        active: false,
        duration: 4000,
        msg: "",
        stackable: false,
      },
      branchUserInfo:{

      }
    },
    getters: {
      getPageData: (state, getters) => {
        return {
          title: state.pageTitle,
          url: state.pageTitleUrl,
          breadcrumbs: state.breadcrumbs
        };
      },
      getPageLoader(state) {
        return state.pageLoader;
      },
      getUserInfo(state) {
        return state.userInfo;
      },
      getUserType(state) {
        return state.userType;
      },
      getSnackbar(state) {
        return state.activeSnackbar;
      },
      getIMSUserMenu(state) {
        return state.imsUserMenuss;
      },
      getBranchUserInfo(state){
        return state.branchUserInfo;
      }
    },
    mutations: {
      setPageTitle(state, pageData) {
        state.pageTitle = pageData.title;
        state.pageTitleUrl = pageData.url;
        state.breadcrumbs = pageData.breadcrumbs;
      },
      setPageLoader(state, payload) {
        state.pageLoader = payload;
      },
      setUserInfo(state, payload) {
        state.userInfo = payload;
      },
      setUserType(state, payload) {
        state.userType = payload;
      },
      setSnackbar(state, payload) {
        state.activeSnackbar.active = payload.active;
        state.activeSnackbar.duration = payload.duration
          ? payload.duration
          : state.activeSnackbar.duration;
        state.activeSnackbar.stackable =
          payload.stackable === true ? payload.stackable : false;
        state.activeSnackbar.msg = payload.msg;
      },
      setUserMenu(state, payload) {
        state.imsUserMenuss = payload;
      },
      setBranchUserInfo(state,payload){
        state.branchUserInfo=payload;
      }
    },
    actions: {
      setPageTitleAction({ commit }, pageData) {
        commit("setPageTitle", pageData);
      },
      setLoader({ commit }, payload) {
        commit("setPageLoader", payload);
      },
      async getHeaderMenuAction({ commit }, payload) {
        const url = `/userauthservices/menus/module`;
        const headerMenus = await BaseService.getDMSAxiosClient().get(url);
        return headerMenus;
      },
      async getBizUnitListingAction({ commit }, payload) {
        const url = `/userauthservices/menus/business-unit`;
        const bizUnit = await BaseService.getDMSAxiosClient().get(url);
        return bizUnit;
      },
      async getUserMenu({ commit }, payload) {
        const moduleId = localStorage.getItem('moduleId') || 1004;
        const url = `userauthservices/menus/module/${moduleId}/biz-unit/1`;
        const userMenu = await BaseService.getDMSAxiosClient().get(url);
        commit("setUserMenu", userMenu);
        return userMenu;
      },
      async generateUserAuthToken({ commit }, payload) {
        return await BaseService.authenticateToken();
      },
      async fetchUserToken({ commit }, payload) {
        const url = `/scheme-planning/ims/tokenDev`;
        const token = await BaseService.getDMSTokenClient().get(url);
        return token;
      },
      async fetchUserInfo({ commit }, payload) {
        const url = `/userservices/logged-user`;
        const userInfo = await BaseService.getSchemePlanningClient().get(url);
        commit("setUserInfo", userInfo.data);
      },
      async DMSLogOutAction({ commit }, payload) {
        const url = `/userservices/logoff`;
        const resp = await BaseService.getDMSAxiosClient().post(url, payload);
        return resp;
      },
      setSnackbar({ commit }, payload) {
        commit("setSnackbar", payload);
      },
      async getUserType({ commit }, payload) {
        const url = `/scheme-planning/ims/usertype`;
        const resp = await BaseService.getSchemePlanningClient().get(url);
        commit("setBranchUserInfo", resp.data.data);
        return resp.data.data;
      },
    },
    modules: {
      schemePlanning: schemePlanning,
      communication: communication,
      masters: masters,
      menus: menus,
      workflow: workflow,
      accrual: accrual,
      configuration: configuration,
      reports: reports,
      branchScheme: branchScheme,
      tradePlan: tradePlan,
      bulkPayoutManualUpload: bulkPayoutManualUpload,
      nerp: nerp,
    },
  }